import Constants from '@constants'
import { isLoggedIn } from '@utils/auth'
import { fetchDepartmentsApi } from './api'
import { getHierarchyConfigApi } from '@components/hierarchy-config/hierarchy-api'
export const state = {
  departments: [],
}

export const getters = {
  departments(state) {
    return state.departments
  },
  departmentOptions(state) {
    return state.departments
    // const departments = state.departments
    // return departments.map((p) => ({
    //   color: p.color,
    //   key: p.id,
    //   text: p.name,
    // }))
  },
}

export const mutations = {
  SET_DEPARTMENTS(state, data) {
    state.departments = data
  },
}

export const actions = {
  init({ dispatch }) {
    if (isLoggedIn()) {
      dispatch('fetch')
    }
  },

  fetch({ commit }, params) {
    return fetchDepartmentsApi(false, params).then((data) => {
      commit('SET_DEPARTMENTS', data)
      return data
    })
  },

  /**
   * destroy all states when user is logged out
   */
  destroy({ commit }) {
    commit('SET_DEPARTMENTS', [])
  },
}

function getDepartmentConfig() {
  const vuexModule = {
    namespaced: true,
  }
  vuexModule.state = {
    departmentConfig: {},
  }

  vuexModule.getters = {
    departmentConfig(state) {
      return state.departmentConfig
    },
    allowedRequestLeafNode(state) {
      return state.departmentConfig.allowedRequestLeafNode
    },
    allowedProblemLeafNode(state) {
      return state.departmentConfig.allowedProblemLeafNode
    },
    allowedChangeLeafNode(state) {
      return state.departmentConfig.allowedChangeLeafNode
    },
    allowedReleaseLeafNode(state) {
      return state.departmentConfig.allowedReleaseLeafNode
    },
    reportHierarchy(state) {
      return state.departmentConfig.reportHierarchy
    },
  }

  vuexModule.mutations = {
    SET_HIERARCHY_CONFIG(state, data) {
      state.departmentConfig = data
    },
  }

  vuexModule.actions = {
    init({ dispatch }) {
      if (isLoggedIn()) {
        dispatch('fetchConfig')
      }
    },

    fetchConfig({ commit, rootGetters }, params) {
      getHierarchyConfigApi(Constants.DEPARTMENT).then((data) => {
        commit('SET_HIERARCHY_CONFIG', Object.freeze(data))
      })
    },

    /**
     * destroy all states when user is logged out
     */
    destroy({ commit }) {
      commit('SET_HIERARCHY_CONFIG', {})
    },
  }
  return vuexModule
}

export const modules = {
  departmentConfig: getDepartmentConfig(),
}
